import React, { Component } from 'react';
import Select from 'react-select'
import InputText, { InputSelect, InputSelectMagasin } from '../../../../commonModules/interface/form-input-inline.jsx';
import FormLayout from '../containers/FormLayout.jsx';
import { TableCell, TableRow, Button, Box } from '@material-ui/core';
import { AddCircleRounded } from '@material-ui/icons';


class FormCommercialReturn extends Component {
    state = { }

    createShopList = () => {
        const list = []
        const { SHOPS } = this.props
        Object.keys(SHOPS).map( ID => { 
            const shop = SHOPS[ID]       
            let selected = !!shop.shop_disabled

            if( this.props.rea.shop_id === ID ) {  // already selected   
                selected = true 
            } 
            list.push ({
                value:ID, 
                label:shop.name, 
                disabled:selected
            })
        })
        
        return list
    }

    createCommercialList = () => {
        const list = []
        const { AGENTS } = this.props
        if( AGENTS ){
            Object.values(AGENTS).map( agent => { 
                let selected = false
                if(this.props.rea.commercial_id === agent.id) {  // already selected   
                    selected = true 
                } 
                list.push (       
                    {value:agent.id, label:`${agent.name} - ${agent.id}`, disabled:selected} 
                )
            })
        }
        return list
    }

    render() {
        const shops = this.createShopList()
        const commercials = this.createCommercialList()

        return (
            <Box p={2}>
                <InputSelectMagasin
                    options={shops}
                    value={this.props.rea.shopDisplay}
                    onChange={ option => this.props.handleSelect(option, "shop_id")}
                    // isOptionDisabled={ option => option.disabled === true}
                    error={this.props.errors.shop_id}
                    label="Magasin"
                /> 
                    
                <InputSelectMagasin
                    options={commercials}
                    value={this.props.rea.commercialDisplay}
                    onChange={ option => this.props.handleSelect(option, "commercial_id")}
                    // isOptionDisabled={ option => option.disabled === true}
                    error={this.props.errors.commercial_id}
                    label="Commercial"
                /> 

                <Box p={1} >
                    {/* <FormLayout title={"Produits"} rea >
                        {this.props.createAddForm()}
                        <TableRow className="plus-btn" onClick={this.props.handleAddProd}>
                            <TableCell colSpan={4}>
                                <a> 
                                    <AddCircleRounded />
                                    <span>Ajouter un produit</span> 
                                </a>
                            </TableCell>
                        </TableRow>
                    </FormLayout> */}
                    <FormLayout 
                        {...this.props} 
                        title={"Produits"}
                        rea
                        createAddForm={this.props.createAddForm}
                        onClick={this.props.handleAddProd}
                        onClickForCSVUpload={this.props.handleAddProdByCSV}
                        colSpan={2}
                    /> 
                </Box>
                
                <Box p={2} >
                    <Button color="primary" variant="contained" onClick={this.props.validate}>Valider</Button>
                    <Button color="primary" onClick={this.props.handleClose}>Annuler</Button>
                </Box>
            </Box>
        );
    }
}

export default FormCommercialReturn;